<template>
  <div id="Circles" :class="[configuratorOpen ? 'open' : 'closed']">
    <CircleSelect
      :configurationGroup="configurationGroup"
      :should-set-row="true"
      :is-stacked-configurator="isStackedConfigurator"
      :configurator-open="configuratorOpen"
      :show-divider="showDivider"
      @input="onCheckChange($event)"
      @toggleConfigurator="onConfiguratorClick"
    />
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import CircleSelect from '../CircleSelect.vue';

export default {
  name: 'Circles',
  components: {
    CircleSelect,
  },
  props: {
    configurationGroup: Object,
    configuratorId: Number,
    isStackedConfigurator: {
      default: false,
    },
    showDivider: Boolean,
  },
  computed: {
    ...mapState('product', ['currentOpenConfigurator']),
    configuratorOpen() {
      return this.configuratorId === this.currentOpenConfigurator;
    },
  },
  methods: {
    ...mapMutations('product', ['updateCurrentOpenConfigurator']),
    onCheckChange(event) {
      this.$emit('input', event);
    },
    onConfiguratorClick() {
      if (this.isStackedConfigurator) {
        this.updateCurrentOpenConfigurator(this.configuratorId);
      }
    },
  },
};
</script>
